var React = require('react');

function PurplePinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.69194 0C4.2986 0 0.724365 3.57423 0.724365 7.96753C0.724365 13.4198 7.85457 21.4239 8.15814 21.762C8.44328 22.0796 8.94112 22.079 9.22574 21.762C9.52932 21.4239 16.6595 13.4198 16.6595 7.96753C16.6594 3.57423 13.0852 0 8.69194 0ZM8.69194 11.9762C6.48154 11.9762 4.6833 10.1779 4.6833 7.96753C4.6833 5.75713 6.48158 3.95889 8.69194 3.95889C10.9023 3.95889 12.7005 5.75717 12.7005 7.96758C12.7005 10.178 10.9023 11.9762 8.69194 11.9762Z","fill":"#4F48ED"}));
}

PurplePinInline.defaultProps = {"width":"17","height":"22","viewBox":"0 0 17 22","fill":"none"};

module.exports = PurplePinInline;

PurplePinInline.default = PurplePinInline;
